var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.isLoaded)?_c('Base',{ref:"baseComponent",attrs:{"on-submit":_vm.onSubmit,"triger-prevent":_vm.trigerPrevent,"field-details-route":_vm.fieldDetailsRoute,"templates-route":_vm.templatesRoute,"show-teams":_vm.showTeams,"isOne":_vm.isOne,"isTicket":_vm.isTicket,"groupName":_vm.groupName}}):_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }